export const getIsNavigatingBack = state => state.isNavigatingBack;
export const getResultsScrollTop = state => state.resultsScrollTop;
export const getSelfServiceSearch = state => state.search;
export const getSelectedAnswer = state => state.selectedAnswer;
export const getSearchTerm = state => state.searchTerm;
export const getIsThrottled = state => state.isThrottled;

export default {
  getIsNavigatingBack,
  getIsThrottled,
  getResultsScrollTop,
  getSelfServiceSearch,
  getSelectedAnswer,
  getSearchTerm,
};
